import React from 'react';

const CornerLoaderContext = React.createContext();

export default CornerLoaderContext;
